define(["exports", "react"], function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.useClientRect = useClientRect;

  function useClientRect() {
    var _useState = (0, _react.useState)(null),
        rect = _useState[0],
        setRect = _useState[1];

    var ref = (0, _react.useCallback)(function (node) {
      if (node !== null) {
        setRect(node.getBoundingClientRect());
      }
    }, []);
    return [rect, ref];
  }
});